import {Grid, LinkButton, Logo as LogoBase} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'
import {config, isMarketIntegration} from 'src/shared/config'
import {useTheme} from 'src/shared/hooks'
import i18n from 'src/shared/i18n'
import {isSellAndBuy, isUsp} from 'src/shared/utils'

import {useMarginRef} from '../margin-provider'
import uslugiLogoSrc from './assets/uslugi-logo-expanded.svg'
import {additionalClasses, classes} from './styles'
import type {Variant} from './types'

type Props = {
  variant?: Variant
}

const Header: React.FC<Props> = ({variant}) => {
  const brand = config.brand
  const isUspService = isUsp()
  const isDark = useTheme() === 'dark'
  const ref = useMarginRef<HTMLDivElement>(el => ({
    top: el.clientHeight,
  }))

  const renderLogo = () => {
    if (isUspService) {
      return <img alt="Яндекс Помощник" src={uslugiLogoSrc} />
    }

    if (isMarketIntegration || isSellAndBuy()) {
      return <LogoBase brand={brand} component="div" lang={config.lang} />
    }

    // Тёмная тема: свой логотип с коробочкой и белым текстом (classes.logoDark).
    // Не через блочный invert (теряет коробочку) и не через CSS-подмену фона по
    // [class*='brand_yandex'] (в prod классы минифицируются, селектор не матчит).
    if (isDark && brand !== 'yango') {
      return <a aria-label="Яндекс Доставка" className={classes.logoDark} href="/" />
    }

    return <LogoBase brand={brand} component="a" href="/" lang={config.lang} />
  }

  return (
    <Grid
      alignItems="center"
      className={clsx(
        classes.root,
        variant && classes[`variant_${variant}`],
        isMarketIntegration && additionalClasses.isYandexIntegration,
      )}
      container
      ref={ref}
    >
      {renderLogo()}
      {brand !== 'yango' && !isMarketIntegration && !isUspService && (
        <LinkButton className={classes.button} href="/" size="s">
          {i18n.print('route_delivery_for_business', 'Доставка для бизнеса')}
        </LinkButton>
      )}
    </Grid>
  )
}

export default Header
